import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {emptyFn} from "shared";

import styles from './TextArea.module.scss';

export const TextArea = (props) => {
    const {
        label = false,
        placeholder,
        help,
        className,
        error,
        required,
        onChange,
        onBlur,
        value,
        ...other
    } = props;

    return (
        <div
            className={clsx('form-group d-flex flex-column', styles.input, className)}>
            {label && (<label> {required && <span className="required">*</span>} {label}</label>)}
            <textarea
                rows={2}
                onChange={onChange}
                onBlur={onBlur}
                className={clsx('form-control', styles.inputInner, {"is-invalid": error})}
                style={{paddingLeft: "10px"}}
                placeholder={placeholder}
                value={value}
                {...other}/>

            {help && !error && <small className="form-text text-muted">{help}</small>}
            {error && <small className={clsx('form-text', styles.invalidFeedback)}>{error}</small>}
        </div>
    );
};

TextArea.defaultProps = {
    help: '',
    placeholder: '',
    className: '',
    onChange: emptyFn,
    onBlur: emptyFn,
    value: '',
};

TextArea.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    help: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
};

export default TextArea;
